export const prepareAssetForTransit = (assetData: Buffer) =>
  assetData.toString("base64");
